document.querySelectorAll('[data-ft-product]').forEach(root=>{
if(root.dataset.ftGalleryReady)return;root.dataset.ftGalleryReady='true';
const image=root.querySelector('.ft-main-image'),zoom=root.querySelector('[data-ft-zoom]');
let imageTimer=0,fullTimer=0;
const imageSizes='(max-width: 700px) 95vw, (max-width: 1600px) 48vw, 760px';
function setImage(target,src,alt,fullscreen=false){
 const url=new URL(src,location.origin);
 const width=Math.min(fullscreen?2400:1800,Math.ceil((fullscreen?window.innerWidth:Math.max(zoom.clientWidth,480))*Math.min(window.devicePixelRatio||1,2)));
 url.searchParams.set('width',String(width));
 target.decoding='async';
 target.removeAttribute('srcset');
 target.removeAttribute('sizes');
 if(alt)target.alt=alt;
 if(target.src!==url.href)target.src=url.href;
}
function show(src,large,alt){
 if(!image||!src)return;
 clearTimeout(imageTimer);
 zoom.setAttribute('aria-busy','true');
 imageTimer=setTimeout(()=>{
  image.onload=image.onerror=()=>zoom.removeAttribute('aria-busy');
  setImage(image,src,alt);
  if(image.complete)zoom.removeAttribute('aria-busy');
 },120);
}
const thumbs=[...root.querySelectorAll('[data-ft-image]')], strip=root.querySelector('.ft-thumbnails'), counter=root.querySelector('[data-ft-counter]'), prev=root.querySelector('[data-ft-prev]'), next=root.querySelector('[data-ft-next]');
let index=Math.max(0,thumbs.findIndex(b=>new URL(b.dataset.ftImage,location.origin).pathname===new URL(image?.src||location.href,location.origin).pathname));
const dialog=root.querySelector('[data-ft-lightbox]'),track=root.querySelector('[data-ft-lightbox-track]'),fullPrev=root.querySelector('[data-ft-lightbox-prev]'),fullNext=root.querySelector('[data-ft-lightbox-next]'),fullCount=root.querySelector('[data-ft-lightbox-count]');
let fullIndex=0,oldOverflow='',wheelAt=0,touchStart=null,swiped=false;
const viewerSlide=document.createElement('div'),viewerImage=new Image();
viewerSlide.className='ft-lightbox-slide';
viewerImage.draggable=false;viewerImage.decoding='async';
viewerSlide.append(viewerImage);
track?.replaceChildren(viewerSlide);
if(track){track.style.overflow='hidden';track.style.scrollSnapType='none';track.style.touchAction='pan-y pinch-zoom';}
function fullGo(i){
 fullIndex=Math.max(0,Math.min(i,thumbs.length-1));
 fullCount.textContent=(fullIndex+1)+' / '+thumbs.length;
 fullPrev.disabled=fullIndex===0;fullNext.disabled=fullIndex===thumbs.length-1;
 clearTimeout(fullTimer);
 fullTimer=setTimeout(()=>{
  if(!dialog.open)return;
  const b=thumbs[fullIndex];
  setImage(viewerImage,b.dataset.ftLarge||b.dataset.ftImage,b.dataset.ftAlt||image.alt,true);
 },120);
}
function cleanClose(){
 if(!dialog.open)return;
 clearTimeout(fullTimer);
 document.documentElement.style.overflow=oldOverflow;
 viewerImage.removeAttribute('src');
 dialog.close();
 select(fullIndex);
 zoom.focus({preventScroll:true});
}
zoom?.addEventListener('click',()=>{
 if(!dialog||!thumbs.length||dialog.open)return;
 clearTimeout(imageTimer);zoom.removeAttribute('aria-busy');
 oldOverflow=document.documentElement.style.overflow;
 document.documentElement.style.overflow='hidden';
 dialog.showModal();fullGo(index);
 root.querySelector('[data-ft-close]').focus();
});
root.querySelector('[data-ft-close]')?.addEventListener('click',cleanClose);
dialog?.addEventListener('cancel',e=>{e.preventDefault();cleanClose();});
dialog?.addEventListener('click',e=>{
 if(swiped){swiped=false;return;}
 if(e.target===dialog||e.target===track||e.target===viewerSlide)cleanClose();
});
fullPrev?.addEventListener('click',()=>fullGo(fullIndex-1));
fullNext?.addEventListener('click',()=>fullGo(fullIndex+1));
dialog?.addEventListener('keydown',e=>{
 if(['ArrowRight','ArrowLeft','Home','End'].includes(e.key)){
  e.preventDefault();
  fullGo(e.key==='Home'?0:e.key==='End'?thumbs.length-1:fullIndex+(e.key==='ArrowRight'?1:-1));
 }
});
track?.addEventListener('wheel',e=>{
 if(e.ctrlKey)return;
 const delta=Math.abs(e.deltaX)>Math.abs(e.deltaY)?e.deltaX:e.deltaY;
 e.preventDefault();
 if(Math.abs(delta)<8||performance.now()-wheelAt<250)return;
 wheelAt=performance.now();fullGo(fullIndex+(delta>0?1:-1));
},{passive:false});
track?.addEventListener('touchstart',e=>{
 swiped=false;touchStart=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;
},{passive:true});
track?.addEventListener('touchend',e=>{
 if(!touchStart)return;
 const dx=e.changedTouches[0].clientX-touchStart.x,dy=e.changedTouches[0].clientY-touchStart.y;
 touchStart=null;
 if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){e.preventDefault();swiped=true;fullGo(fullIndex+(dx<0?1:-1));}
},{passive:false});
window.addEventListener('resize',()=>{if(dialog?.open)fullGo(fullIndex);});
function select(i,scroll=true){index=Math.max(0,Math.min(i,thumbs.length-1));const b=thumbs[index];if(!b)return;if(scroll)show(b.dataset.ftImage,b.dataset.ftLarge,b.dataset.ftAlt);thumbs.forEach((t,n)=>t.setAttribute('aria-pressed',String(n===index)));counter.textContent=(index+1)+' / '+thumbs.length;prev.disabled=index===0;next.disabled=index===thumbs.length-1;if(scroll){/* only move the strip when the thumb isn't fully visible; position from bounding boxes (offsetLeft is already relative to the positioned strip) (fix 2026-10-03) */const sr=strip.getBoundingClientRect(),br=b.getBoundingClientRect();if(br.left<sr.left||br.right>sr.right){const max=strip.scrollWidth-strip.clientWidth;strip.scrollTo({left:Math.max(0,Math.min(max,strip.scrollLeft+(br.left-sr.left)-(sr.width-br.width)/2)),behavior:'smooth'});}}}
thumbs.forEach((b,i)=>b.addEventListener('click',()=>select(i)));
prev.addEventListener('click',()=>select(index-1));next.addEventListener('click',()=>select(index+1));
strip.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();select(index+(e.key==='ArrowRight'?1:-1));thumbs[index].focus({preventScroll:true});}});
let touchX;zoom?.addEventListener('touchstart',e=>{touchX=e.changedTouches[0].clientX;},{passive:true});zoom?.addEventListener('touchend',e=>{const delta=e.changedTouches[0].clientX-touchX;if(Math.abs(delta)>45){e.preventDefault();select(index+(delta<0?1:-1));}},{passive:false});
if(thumbs.length)select(index,false);root.querySelector('.ft-gallery-controls').hidden=thumbs.length<2;strip.hidden=thumbs.length<2;
root.querySelector('[data-ft-variant]')?.addEventListener('change',event=>{
const option=event.target.selectedOptions[0],available=option.dataset.available==='true';
root.querySelector('[data-ft-price]').textContent=option.dataset.price;
const compare=root.querySelector('[data-ft-compare]');compare.textContent=option.dataset.compare;compare.hidden=option.dataset.sale!=='true';
root.querySelector('[data-ft-stock]').textContent=available?'Available to order':'Sold out';
const add=root.querySelector('[data-ft-add]');add.disabled=!available;add.innerHTML=available?'Add to cart<span class=\"ft-arrow\" aria-hidden=\"true\"></span>':'Sold out';
const quantity=root.querySelector('[name="quantity"]');quantity.min=option.dataset.min;quantity.step=option.dataset.step;if(option.dataset.max)quantity.max=option.dataset.max;else quantity.removeAttribute('max');quantity.value=option.dataset.min;
if(option.dataset.image){const selected=thumbs.findIndex(b=>b.dataset.ftImage===option.dataset.image);if(selected>=0)select(selected);else show(option.dataset.image,option.dataset.large);}
const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
});
});
/* 2026-10-07: Add to cart on product pages opens the slide-out bag (same as the cards) instead of jumping to /cart. Falls back to the normal form post if the bag script is missing or the request fails. */
document.addEventListener('submit',async event=>{
const form=event.target.closest('form.ft-purchase');if(!form||!window.BMBag||!window.fetch)return;
event.preventDefault();const add=form.querySelector('[data-ft-add]');if(add&&add.disabled)return;
const label=add?add.innerHTML:'';if(add){add.disabled=true;add.textContent='Adding…';}
try{const response=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});const data=await response.json().catch(()=>({}));
if(!response.ok){if(add){add.textContent=data.description||'Could not add';setTimeout(()=>{add.innerHTML=label;add.disabled=false;},2200);}return;}
await window.BMBag.open();if(add){add.innerHTML=label;add.disabled=false;}}
catch(error){if(add){add.innerHTML=label;add.disabled=false;}form.submit();}
});
